<ng-container *ngIf="mediaStructure.isUploading">
  <td colspan="3">
    <nz-progress [nzPercent]="mediaStructure.Percent" nzSize="small" [nzShowInfo]="false"
      style="vertical-align: middle"></nz-progress>
  </td>
</ng-container>
<ng-container *ngIf="!mediaStructure.isUploading">
  <td style="width: 250px">
    <div style="width: 218px; height: 125px; font-size: 48px; text-align: center">
      <ng-container *ngIf="isImage && !mediaStructure.isVideo">
        <!-- For Base64 files -->
        <!-- <img (click)="onPreviewBtn()" [src]="mediaStructure.thumbData" style="max-width: 218px; max-height: 125px;" /> -->

        <!-- For media on the same server -->

        <img *ngIf="mediaStructure.fullPath" [src]="
    (mediaStructure.type === 'link' ?
     mediaStructure.mediaLink
      : mediaStructure.fullPath) | safeHtml:'url'"
       alt="" style="max-width: 218px; max-height: 125px" (click)="onPreviewBtn()" />


        <!-- <img
        *ngIf="mediaStructure.fullPath"
          [src]="
            (mediaStructure.type === 'link'
              ? mediaStructure.mediaLink
              : url +
                'api/Media/get-media?path=' +
                (mediaStructure.fullPath! | safeHtml : 'encodeUrl')
            ) | safeHtml : 'url'
          "
          alt=""
          style="max-width: 218px; max-height: 125px"
          (click)="onPreviewBtn()"
        /> -->
      </ng-container>
      <ng-container *ngIf="isImage && mediaStructure.isVideo">
        <iframe [src]="mediaStructure.mediaLink | safeHtml : 'resourceUrl'" frameborder="0" allowfullscreen
          style="max-width: 218px; max-height: 125px">
        </iframe>
      </ng-container>
      <ng-container *ngIf="!isImage">
        <i class="fa-light fa-file"></i>
      </ng-container>
    </div>
  </td>
  <td>
    {{ mediaStructure.originalName }}
    <br />
    <span nz-typography nzType="secondary">
      <span *ngIf="mediaStructure.width > 0">
        {{ mediaStructure.width + " x " + mediaStructure.height }}
      </span>
      &nbsp;&nbsp;
      <span *ngIf="mediaStructure.FileSize > 0">{{
        mediaStructure.FileSize + "kb"
        }}</span>
    </span>
    <br />
    <nz-form-item>
      <nz-form-label [nzSpan]="6"> Alternative Text </nz-form-label>
      <nz-form-control [nzSpan]="18">
        <input nz-input [(ngModel)]="mediaStructure.AltText" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="
        mediaStructure.Roles !== null &&
        mediaStructure.Roles !== undefined &&
        mediaStructure.Roles.length > 0
      ">
      <nz-form-label [nzSpan]="6"> {{'Rules' | translate}} </nz-form-label>
      <nz-form-control [nzSpan]="18">
        <nz-select [(ngModel)]="mediaStructure.Roles" nzMode="multiple" nzSize="default" style="width: 100%"
          [nzDisabled]="true" style="align-content: center">
          <nz-option nzLabel="Base" nzValue="1"></nz-option>
          <nz-option nzLabel="Small" nzValue="2"></nz-option>
          <nz-option nzLabel="Thumbnail" nzValue="3"></nz-option>
          <nz-option nzLabel="Swatch" nzValue="4"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </td>
  <td style="width: 150px">
    <nz-button-group>
      <a nz-button (click)="onDownloadBtn()" *ngIf="!mediaStructure.isLink">
        <i class="fa-light fa-download"></i>
        &nbsp;&nbsp; {{'Download' | translate}}
      </a>
      <a nz-button nzType="default" nzDanger (click)="onDeleteBtn()">
        <i class="fa-light fa-trash"></i>
        &nbsp;&nbsp; {{'Delete' | translate}}
      </a>
    </nz-button-group>
  </td>
</ng-container>

<nz-drawer *ngIf="isImage" [nzWrapClassName]="'drawer-size-3x'" [nzVisible]="DrawerVisible"
  (nzOnClose)="onDrawerClose($event)" [nzWidth]="'1000px'">
  <ng-container *nzDrawerContent>
    <nz-space nzDirection="vertical" nzSize="large"></nz-space>

    <br />
    <br />
    <nz-row>
      <div nz-col nzSpan="20" nzOffset="4">
        <img *ngIf="isImage && !mediaStructure.isVideo" nz-image
          [src]="mediaStructure.thumbData | safeHtml : 'resourceUrl'" [style.width.px]="mediaStructure.widthPercent * 8"
          [style.height.px]="mediaStructure.HightPercent * 8" [alt]="mediaStructure.AltText" />
        <iframe *ngIf="isImage && mediaStructure.isVideo" [style.width.px]="mediaStructure.HightPercent * 8"
          [style.height.px]="mediaStructure.HightPercent * 8"
          [src]="mediaStructure.mediaLink | safeHtml : 'resourceUrl'" frameborder="0" allowfullscreen></iframe>
      </div>
    </nz-row>

    <br />
    <br />
    <nz-row>
      <div nz-col nzSpan="4" nzOffset="4">{{'Alternative Text' | translate}}</div>
      <div nz-col nzSpan="12">
        <p nz-typography nzEditable nzEditIcon="highlight" [nzEditTooltip]="'click to edit text' | translate"
          [(nzContent)]="mediaStructure.AltText"></p>
      </div>
    </nz-row>

    <nz-row>
      <div nz-col nzSpan="4" nzOffset="4">{{'Name' | translate}}</div>
      <div nz-col nzSpan="12">
        <p nz-typography nzEditIcon="highlight" [nzEditTooltip]="'click to edit text' | translate"
          [nzContent]="mediaStructure.originalName"></p>
      </div>
    </nz-row>
    <nz-row>
      <div nz-col nzSpan="4" nzOffset="4">{{'Dimension' | translate}}</div>
      <div nz-col nzSpan="12">
        <p nz-typography nzEditIcon="highlight" [nzEditTooltip]="'click to edit text' | translate"
          [nzContent]="mediaStructure.width + ' X ' + mediaStructure.height"></p>
      </div>
    </nz-row>
    <nz-row>
      <div nz-col nzSpan="4" nzOffset="4">{{'Size' | translate}}</div>
      <div nz-col nzSpan="12">
        <p nz-typography nzEditIcon="highlight" [nzEditTooltip]="'click to edit text' | translate"
          [nzContent]="mediaStructure.FileSize + 'kb'"></p>
      </div>
    </nz-row>

    <nz-row>
      <div nz-col nzSpan="4" nzOffset="4">{{'Role' | translate}}</div>
      <div nz-col nzSpan="12">
        <nz-select [(ngModel)]="mediaStructure.Roles" nzMode="multiple" [nzPlaceHolder]="'Please select' | translate"
          nzSize="default" style="width: 100%" (ngModelChange)="onRoleSelect()">
          <nz-option nzLabel="Base" nzValue="1"></nz-option>
          <nz-option nzLabel="Small" nzValue="2"></nz-option>
          <nz-option nzLabel="Thumbnail" nzValue="3"></nz-option>
          <nz-option nzLabel="Swatch" nzValue="4"></nz-option>
        </nz-select>
      </div>
    </nz-row>
  </ng-container>
</nz-drawer>